// extracted by mini-css-extract-plugin
export var formContainer = "_k7-0";
export var message = "_k7-1";